import { DATE_FORMATS_FNS } from "components";
import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";
import { formatCurrentUTCDate } from "utils/dateHelperFunctions";

import type { Pin } from "models";
import type { AppendPinPayload } from "modules/AppointmentDetails/components/Interventions/hooks";

export const useAddPinNotesAndAttachmentsMutation = () =>
  useTypedMutation({
    mutationFn: async ({ note, visible_important_items, note_attachments, intervention_id }: AppendPinPayload) =>
      (await ApiInstance.post("/pins/add_note", { note, visible_important_items, note_attachments, intervention_id })).data.pin_id,
    onSuccess: (payload, pin_id: number) => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment?.interventions?.length) return;

      const pin: Pin = {
        ...payload,
        id: pin_id,
        question_result_id: null,
        info: false,
        mechanic_fixed: false,
        is_dms: false,
        manufacturer_id: null,
        created_on: formatCurrentUTCDate(DATE_FORMATS_FNS.ISOFormat),
        updated_on: formatCurrentUTCDate(DATE_FORMATS_FNS.ISOFormat)
      };

      const { interventions } = appointment;
      const interventionIdx = interventions.findIndex(i => i.id === pin.intervention_id);
      if (interventionIdx < 0) return;
      const isPinAlreadyInHistory = interventions[interventionIdx].pin_history?.some(p => p.id === pin.id);
      if (isPinAlreadyInHistory) return;

      const intervention = interventions[interventionIdx];
      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, {
        ...appointment,
        interventions: interventions.with(interventionIdx, { ...intervention, pin_history: [...(intervention.pin_history ?? []), pin] })
      });
    }
  });
